import React, { useEffect, useState } from 'react';
import { META_AD_TYPE } from '../SocialMediaConstant';

const InstagramFeedAd = ({
    image,
    message,
    buttonType,
}) => {

    return (
        <div style={{
            width: '295px',
            border: '1px solid #ccc',
            borderRadius: '0.5rem',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            overflow: 'hidden',
            fontFamily: 'sans-serif',
            backgroundColor: 'white'
        }}>
            <div style={{
                display: 'flex', alignItems: 'center', padding: '0.75rem', borderBottom: '1px solid #eee', padding: "0.75rem"
            }}>
                <i className='fa fa-brand fa-instagram pr-2' />
                <span style={{ fontSize: '0.75rem', fontWeight: '600', margin: 0 }}>Instagram Feed</span>
            </div>
            <div style={{
                display: 'flex',
                alignItems: 'start',
                borderBottom: '1px solid #eee',
                justifyContent: 'space-between',
                padding: "15px 20px",
                paddingLeft: "40px",
                paddingBottom: "2px"
            }}>
                <span className='p-0 m-0' style={{ fontSize: '0.625rem', color: '#888' }}>Sponsored</span>
                <span className='p-0 m-0' style={{ fontWeight: 'bold', fontSize: '1.2rem', fontWeight: "900", position: 'relative', bottom: '10px' }}>...</span>
            </div>
            <img
                src={image}
                alt="Ad"
                style={{
                    width: '295px',
                    height: '170px'
                }}
                className="img-fluid object-fit-cover"
            />
            <div style={{
                display: 'flex',
                alignItems: 'start',
                borderBottom: '1px solid #eee',
                justifyContent: 'space-between',
                padding: "15px 20px"
            }}>
                <span style={{ fontSize: '0.625rem', fontWeight: '600' }}>{META_AD_TYPE[buttonType] || 'Learn More'}</span>
                <i className='fa fa-chevron-right' />
            </div>

            {/* Like, Comment, Share Buttons */}
            <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.5rem 0',
                fontSize: '0.75rem',
                color: '#4b5563',
                fontWeight: '600', borderTop: '1px solid #eee',
                padding: '0.75rem',
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-around',

                }}>
                    <span style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', paddingRight: '0.8rem' }}>
                        <i className="fa fa-heart-o fa-lg" />
                    </span>
                    <span style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', paddingRight: '0.8rem' }}>
                        <i className="fa fa-comment-o fa-lg" />
                    </span>
                    <span style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', paddingRight: '0.8rem' }}>
                        <i className="fa fa-paper-plane fa-lg" />
                    </span>
                </div>
                <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                    <i className='fa fa-bookmark-o fa-lg' />
                </div>
            </div>
            <p style={{ padding: '0.5rem 0.75rem', fontSize: '0.75rem', fontWeight: '600', margin: 0 }}>{message}</p>
        </div >
    );
};

export default InstagramFeedAd;
